var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "block--employee block--light  block--listed"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('span', {
    staticClass: "screen-reader-text"
  }, [_vm._v("(Open post)")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "lazy-container",
      rawName: "v-lazy-container",
      value: ({
        selector: 'img'
      }),
      expression: "{ selector: 'img' }"
    }],
    staticClass: "image--right",
    attrs: {
      "href": _vm.postdata.slug
    },
    domProps: {
      "innerHTML": _vm._s(_vm.fixPhotoForLazyLoad(_vm.postdata.photo_html))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "person-desc"
  }, [_c('a', {
    staticClass: "name-link",
    attrs: {
      "href": _vm.postdata.slug
    }
  }, [_c('h3', {
    staticClass: "person-title text--600"
  }, [_vm._v(_vm._s(_vm.postdata.first_name)), _c('br'), _vm._v(_vm._s(_vm.postdata.lastname))]), _vm._v(" "), ((_vm.postdata.position && _vm.postdata.position[0])) ? _c('div', {
    staticClass: "person-position",
    domProps: {
      "innerHTML": _vm._s(_vm.postdata.position[0].name)
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "person-meta text--300"
  }, [(_vm.postdata.emails) ? _c('ul', {
    staticClass: "person-phones"
  }, _vm._l((_vm.postdata.emails), function(email) {
    return (email['email'].indexOf('@bahr') >= 0) ? _c('li', {
      key: email['email']
    }, [_c('a', {
      attrs: {
        "href": 'mailto:' + email['email']
      }
    }, [_vm._v(_vm._s(email['email']))])]) : _vm._e()
  })) : _vm._e(), _vm._v(" "), (_vm.postdata.phone_numbers) ? _c('ul', {
    staticClass: "person-phones"
  }, _vm._l((_vm.postdata.phone_numbers), function(number) {
    return (number['phone_number'].length > 8) ? _c('li', {
      key: number['phone_number']
    }, [_c('a', {
      attrs: {
        "href": 'tel:' + number['phone_number']
      }
    }, [_vm._v(_vm._s(number['phone_number']))])]) : _vm._e()
  })) : _vm._e()])])])])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6955dd42","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/vue/components/singleEmploye.vue
// module id = 241
// module chunks = 0